import Component from '../Component';
import classList from '../utils/classList';
import Icon from './Icon';
export default class ColorPreviewInput extends Component {
  view(vnode) {
    const {
      className,
      id,
      ...otherAttrs
    } = this.attrs;
    const attrs = otherAttrs;
    attrs.type ||= 'text';
    attrs.onblur = () => {
      if (attrs.value.length === 4) {
        attrs.value = attrs.value.replace(/#([a-f0-9])([a-f0-9])([a-f0-9])/, '#$1$1$2$2$3$3');
        attrs.onchange?.({
          target: {
            value: attrs.value
          }
        });
      }

      // Validate the color
      if (!/^#[a-f0-9]{6}$/i.test(attrs.value)) {
        attrs.value = '#000000';
        attrs.onchange?.({
          target: {
            value: attrs.value
          }
        });
      }
    };
    return m("div", {
      className: "ColorInput"
    }, m("input", Object.assign({
      className: classList('FormControl', className),
      id: id
    }, attrs)), m("span", {
      className: "ColorInput-icon",
      role: "presentation"
    }, m(Icon, {
      name: 'fas fa-exclamation-circle'
    })), m("input", Object.assign({
      className: "ColorInput-preview"
    }, attrs, {
      type: "color"
    })));
  }
}
flarum.reg.add('core', 'common/components/ColorPreviewInput', ColorPreviewInput);